import React from 'react';
import PropTypes from 'prop-types';

const IconMaintenanceTool = ({ width = 16, height = 16, viewBox = '0 0 16 16', color = 'none' }) => {
	return <svg width={width} height={height} viewBox={viewBox} fill='none' xmlns='http://www.w3.org/2000/svg'>
		<rect width='16' height='16' fill={color} />
		<path d='M12.8413 4.80275L10.3738 7.2725L8.73129 5.6285L11.1988 3.1595L10.79 2.75H8.73804L6.68004 4.80275V7.682L4.87629
		9.4865L4.53279 9.83L3.12354 11.24C2.95612 11.3973 2.83806 11.5998 2.78373 11.823C2.72939 12.0462 2.74114 12.2804 2.81754
		12.497C2.88772 12.6787 3.00194 12.8401 3.14992 12.9667C3.2979 13.0934 3.47502 13.1813 3.66537 13.2225C3.85572 13.2638 4.05333
		13.2571 4.24047 13.2032C4.42761 13.1492 4.59841 13.0496 4.73754 12.9133L5.62779 12.0215L5.94954 11.6788L8.32179 9.326H11.1988L13.25
		7.2725V5.21975L12.8413 4.80275Z' fill='white' />
	</svg>;
};

IconMaintenanceTool.propTypes = {
	width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	color: PropTypes.string,
	viewBox: PropTypes.string,
};
export default IconMaintenanceTool;
